<template>
  <div class="vac-room-header vac-app-border-b">
    <slot name="room-header">
      <div class="vac-room-wrapper">
        <transition name="vac-slide-up">
          <div v-if="messageSelectionEnabled" class="vac-room-selection"
               style="display: flex;justify-content: space-between">
            <div
                v-for="action in messageSelectionActions"
                :id="action.name"
                :key="action.name"
            >
              <el-button
                  type="primary"
                  size="small"
                  @click="messageSelectionActionHandler(action)"
              >
                {{ action.title }}
                <span class="vac-selection-button-count">
									{{ selectedMessagesTotal }}
								</span>
              </el-button>
            </div>
            <div
                class="vac-selection-cancel vac-item-clickable"
                @click="$emit('cancel-message-selection')"
            >
              {{ textMessages.CANCEL_SELECT_MESSAGE }}
            </div>
          </div>
        </transition>
        <template
            v-if="!messageSelectionEnabled && messageSelectionAnimationEnded"
        >
          <div
              v-if="!singleRoom"
              class="vac-svg-button vac-toggle-button"
              :class="{
							'vac-rotate-icon-init': !isMobile,
							'vac-rotate-icon': !showRoomsList && !isMobile
						}"
              @click="$emit('toggle-rooms-list')"
          >
            <slot name="toggle-icon">
              <svg-icon name="toggle"/>
            </slot>
          </div>
          <div
              class="vac-info-wrapper"
              style="display: flex;justify-content: space-between"
          >
            <div style="display: flex;cursor: pointer;" @click="handleOpenDrawer">
              <slot name="room-header-avatar">
                <div class="middle">
                  <div class="avatar_wrap">
                    <el-image
                        v-if="hasCustomAvatar"
                        class="avatar"
                        :src="resolvedAvatar"
                        fit="cover"
                    >
                      <template #error>
                        <div class="avatar_placeholder"/>
                      </template>
                    </el-image>
                    <div
                        v-else
                        class="vac-avatar"
                        :style="{ 'background-image': `url('${resolvedAvatar}')` }"
                    />
                  </div>
                </div>
              </slot>
              <slot name="room-header-info">
                <div class="vac-text-ellipsis" style="margin-left: 5px;">
                  <div class="vac-room-name vac-text-ellipsis">
                    <div style="display: flex;justify-content: space-between;align-items: center">
                    <span style="display: flex;align-items: center">
                      <span style="display: flex;flex-direction: column;">
                        <span class="username">
                          <span>{{ displayRoomName }}</span>
                          <MyCustomer v-if="isMyCustomer" @click="handleOpenCustomerDrawer" />
                        </span>
                      </span>
                    </span>
                    </div>
                  </div>
                  <div v-if="typingUsers" class="vac-room-info vac-text-ellipsis">
                    {{ typingUsers }}
                  </div>
                  <div v-else class="vac-room-info vac-text-ellipsis">
                    {{ userStatus }}
                    <span v-if="!room.isTemp && lastLoginDisplay" class="last-time">{{ $t('whatsapp.roomHeader.lastLogin') }}: {{ lastLoginDisplay }}</span>
                  </div>
                </div>
              </slot>
            </div>
            <div v-if="!room.isTemp">
               <span style="display: inline-flex;align-items: center">
                      <img
                          style="width: 16px;height: auto;margin: 0px 14px;cursor: pointer"
                          src="@/modules/whatsapp/img/wa_search.png"
                          @click="$emit('show-right-info', 'search')"
                      />
                      <el-dropdown
                          placement="bottom-start"
                          trigger="click"
                          popper-class="vac-el-dropdown"
                          style="width: max-content !important;"
                          @command="handleCommand"
                      >
                        <img
                            style="width: 16px;height:auto;margin: 0px 14px;cursor: pointer;padding: 10px 0px;"
                            src="@/modules/whatsapp/img/wa_more.png"
                        />
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item command="info">{{ $t('whatsapp.roomHeader.viewInfo') }}</el-dropdown-item>
                            <!-- <el-dropdown-item command="star">{{ $t('whatsapp.roomHeader.specialAttention') }}</el-dropdown-item> -->
                            <el-dropdown-item command="close">{{ $t('whatsapp.roomHeader.closeChat') }}</el-dropdown-item>
                            <!-- <el-dropdown-item command="clearChat">{{ $t('whatsapp.roomHeader.clearChat') }}</el-dropdown-item> -->
                            <!-- <el-dropdown-item command="delete">{{ $t('whatsapp.roomHeader.deleteChat') }}</el-dropdown-item> -->
                             <el-dropdown-item v-if="isGroupRoom" command="leaveGroup">{{ $t('whatsapp.roomHeader.leaveGroup') }}</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </span>
            </div>

          </div>
          <slot v-if="room.roomId" name="room-options">
            <div
                v-if="menuActions.length"
                class="vac-svg-button vac-room-options"
                @click="menuOpened = !menuOpened"
            >
              <slot name="menu-icon">
                <svg-icon name="menu"/>
              </slot>
            </div>
            <transition v-if="menuActions.length" name="vac-slide-left">
              <div
                  v-if="menuOpened"
                  v-click-outside="closeMenu"
                  class="vac-menu-options"
              >
                <div class="vac-menu-list">
                  <div v-for="action in menuActions" :key="action.name">
                    <div
                        class="vac-menu-item"
                        @click="menuActionHandler(action)"
                    >
                      {{ action.title }}
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </slot>
        </template>
      </div>
    </slot>

    <el-drawer
        size="530px"
        v-if="customerDrawerVisible"
        v-model="customerDrawerVisible"
        style="padding: 15px 5px 15px 10px"
        append-to-body
        :z-index="3000"
        direction="rtl"
    >
      <template #header>
        <div style="display: flex;align-items: center">
          <h4 style="color: rgba(0, 0, 0, .85);font-weight: 500;font-size: 16px;line-height: 22px;width: 410px">
            {{ activeCustomerItem?.customerName || '—' }}
          </h4>
          <router-link
              :to="'/email/customer/detail/' + String(activeCustomerId) + '?tabKey=1&type=' + String(activeCustomerItem?.type || 1) + '&teamId=' + String(teamId || '')"
              style="color: #409eff"
          >
            <el-button link type="primary">{{ $t('common.edit') }}</el-button>
          </router-link>
        </div>
      </template>
      <template #default>
        <div v-loading="customerDetailLoading">
          <div class="font_targert">{{ $t('common.customer.number') }}：{{ activeCustomerItem?.customerCode || '—' }}</div>
          <div class="font_targert" style="margin: 10px 0px;">{{ $t('common_byinput') }}：{{ activeCustomerItem?.createName || '—' }}</div>
          <div class="font_targert" style="margin: 10px 0px;">{{ $t('common.bybranch') }}：{{ (activeCustomerItem?.mangerVOList || []).map(item => item.managerName).join(',') || '—' }}</div>
          <div class="font_targert">{{ $t('sending.table.col.createTime') }}：{{ activeCustomerItem?.createTime || '—' }}</div>

          <div style="margin-top: 15px">
            <div>
              <div class="customer_title">{{ $t('common.cds25') }}</div>
              <div class="small_box">
                <TableShows :table-data="companyInfo" />
              </div>
            </div>
            <div style="margin-top: 15px">
              <div class="customer_title">{{ $t('common.marketing.information') }}</div>
              <div class="small_box">
                <TableShows :table-data="marketingInfo" />
              </div>
            </div>
            <div style="margin-top: 15px">
              <div class="customer_title">{{ $t('common.contact') }}</div>
              <div
                  class="small_box"
                  v-for="(item, index) in customerContactInfo"
                  :key="index"
              >
                <TableShows :table-data="item" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import SvgIcon from '@/modules/whatsapp/components/SvgIcon/SvgIcon.vue'

import vClickOutside from '@/modules/whatsapp/utils/on-click-outside'
import typingText from '@/modules/whatsapp/utils/typing-text'
import { formatChatTime } from '@/modules/whatsapp/utils/wa-index'
import MyCustomer from "@/modules/whatsapp/components/MyCustomer/index.vue"
import sessionStore from '@/utils/sessionStore'
import TableShows from '@/views/Customer/Tables/TableShows.vue'

import defaultGroupAvatar from '@/modules/whatsapp/img/default_group_avatar.svg'
import defaultUserAvatar from '@/modules/whatsapp/img/default_user_avatar.svg'
import whatsappOfficialAvatar from '@/assets/960px-WhatsApp.svg.webp'

export default {
  name: 'RoomHeader',
  components: {
    SvgIcon,
    MyCustomer,
    TableShows
  },

  directives: {
    clickOutside: vClickOutside
  },

  props: {
    currentUserId: {type: [String, Number], required: true},
    textMessages: {type: Object, required: true},
    singleRoom: {type: Boolean, required: true},
    showRoomsList: {type: Boolean, required: true},
    isMobile: {type: Boolean, required: true},
    roomInfoEnabled: {type: Boolean, required: true},
    menuActions: {type: Array, required: true},
    room: {type: Object, required: true},
    messageSelectionEnabled: {type: Boolean, required: true},
    messageSelectionActions: {type: Array, required: true},
    selectedMessagesTotal: {type: Number, required: true}
  },

  emits: [
    'toggle-rooms-list',
    'room-info',
    'show-right-info',
    'menu-action-handler',
    'room-action-handler',
    'cancel-message-selection',
    'message-selection-action-handler',
    'close-room'
  ],

  data() {
    return {
      menuOpened: false,
      messageSelectionAnimationEnded: true,
      customerDrawerVisible: false,
      customerDetailLoading: false,
      activeCustomerId: '',
      customerContactInfo: [],
      companyInfo: [],
      marketingInfo: []
    }
  },

  computed: {
    isMyCustomer() {
      return this.room?.contactInfo?.isMyCustomer === true
    },
    isOfficialRoom() {
      const rid = String(this.room?.roomId || '').trim()
      return rid === '0@c.us'
    },
    displayRoomName() {
      if (this.isOfficialRoom) return 'WhatsApp'
      return this.room?.roomName
    },
    isGroupRoom() {
      if (this.room?.isGroup === true) return true
      if (this.room?.type === 'group') return true
      const rid = this.room?.roomId
      return typeof rid === 'string' ? rid.includes('@g.us') : false
    },
    resolvedAvatar() {
      if (this.isOfficialRoom) return whatsappOfficialAvatar
      const avatar = this.room?.avatar
      if (typeof avatar === 'string' && avatar.trim()) return avatar
      if (this.isGroupRoom) return defaultGroupAvatar
      return defaultUserAvatar
    },
    hasCustomAvatar() {
      if (this.isOfficialRoom) return true
      const avatar = this.room?.avatar
      return typeof avatar === 'string' && avatar.trim().length > 0
    },
    typingUsers() {
      return typingText(this.room, this.currentUserId, this.textMessages)
    },
    userStatus() {
      if (!this.room.users || this.room.users.length !== 2) return

      const user = this.room.users.find(u => u._id !== this.currentUserId)

      if (!user?.status) return

      let text = ''

      if (user.status.state === 'online') {
        text = this.textMessages.IS_ONLINE
      } else if (user.status.lastChanged) {
        text = this.textMessages.LAST_SEEN + user.status.lastChanged
      }

      return text
    }
    ,
    teamId() {
      return this.$store?.state?.email?.teamID
    },
    activeCustomerItem() {
      return this.$store?.state?.customer?.ruleForm || null
    }
    ,
    lastLoginTimestamp() {
      const v = this.room?.lastLogin
      if (typeof v === 'number' && Number.isFinite(v)) {
        return v > 1e12 ? v : v * 1000
      }
      if (typeof v === 'string' && v.trim()) {
        // Let formatChatTime handle string date parsing
        return v
      }

      const ts = this.room?.lastMessage?.timestamp ?? this.room?.lastMessageTimestamp
      if (typeof ts === 'number' && Number.isFinite(ts)) return ts
      if (typeof ts === 'string' && ts.trim()) return ts
      return null
    },
    lastLoginDisplay() {
      if (!this.lastLoginTimestamp) return ''
      const { date, time } = formatChatTime(this.lastLoginTimestamp)
      if (!date || date === '-') return ''
      // date may already be HH:mm when it's today
      if (date === time) return date
      if (!time || time === '-') return String(date)
      return `${date} ${time}`
    }
  },

  watch: {
    messageSelectionEnabled(val) {
      if (val) {
        this.messageSelectionAnimationEnded = false
      } else {
        setTimeout(() => {
          this.messageSelectionAnimationEnded = true
        }, 300)
      }
    }
  },

  methods: {
    //
    handleClickForward() {

    },
    handleOpenCustomerDrawer() {
      const fallbackId = ''
      const raw = String(this.room?.contactInfo?.customerId || '').trim()
      const cid = raw || fallbackId
      if (!cid) {
        this.$message?.warning?.('customerId 为空，无法打开客户详情')
        return
      }
      this.activeCustomerId = cid
      this.customerDrawerVisible = true
      this.customerDetailLoading = true
      this.customerContactInfo = []
      this.companyInfo = []
      this.marketingInfo = []

      Promise.resolve()
        .then(async () => {
          try {
            sessionStore.set('customerId', cid)
          } catch (e) {
          }

          if (!this.$store) return
          await this.$store.dispatch('customer/getQueryById', { customerId: cid })

          // Build drawer table blocks (same pattern as Customer/Tables)
          try {
            const item = this.$store?.state?.customer?.ruleForm || {}
            const mailCustomerOriginDetailVoList = Array.isArray(item?.mailCustomerOriginDetailVoList) ? item.mailCustomerOriginDetailVoList.filter((x) => x && x.name !== '') : []
            const mailProductDetailVoList = Array.isArray(item?.mailProductDetailVoList) ? item.mailProductDetailVoList.filter((x) => x && x.name !== '') : []

            this.companyInfo = [
              { name: this.$t('common.region.name'), value: item?.zoneAddress || '' },
              { name: this.$t('common.customer.source'), value: mailCustomerOriginDetailVoList.length ? mailCustomerOriginDetailVoList : '' },
              { name: this.$t('common.establishment'), value: item?.setUpTime || '' },
              { name: this.$t('common.economicnature'), value: item?.economicNature || '' },
              { name: this.$t('common.cds6'), value: (() => {
                const list = Array.isArray(item?.emailWayList) ? item.emailWayList : []
                const d = list.find((x) => x && x.isDefault === 1)
                return d?.content || ''
              })() },
              { name: this.$t('common.cds2'), value: item?.companyAddress || '' },
              { name: this.$t('more.check.phone'), value: (() => {
                const list = Array.isArray(item?.phoneWayList) ? item.phoneWayList : []
                const d = list.find((x) => x && x.isDefault === 1)
                return d?.content || ''
              })() },
              { name: this.$t('common.faxnumber'), value: item?.companyFax || '' },
              { name: this.$t('common.company.website'), value: item?.companyWebsite || '' },
              { name: this.$t('other.remark'), value: item?.companyRemark || '' }
            ]

            this.marketingInfo = [
              { name: this.$t('common.customer.type'), value: item?.customerType || '' },
              { name: this.$t('common_customer_level'), value: item?.customerLevel || '' },
              { name: this.$t('common.interest.product'), value: mailProductDetailVoList.length ? mailProductDetailVoList : '' },
              { name: this.$t('create.customer.des'), value: item?.marketingRemark || '' }
            ]
          } catch (e) {
            this.companyInfo = []
            this.marketingInfo = []
          }

          try {
            await this.$store.commit('customer/setContactPage', { page: 1, pageSize: 999 })
          } catch (e) {
          }
          await this.$store.dispatch('customer/getContactList')

          const list = this.$store?.state?.customer?.contactList || []
          this.customerContactInfo = (Array.isArray(list) ? list : []).map((it) => [
            { name: this.$t('common.name'), value: it?.name, isMain: it?.isMain },
            { name: this.$t('common.email'), value: it?.email, isMain: it?.isMain }
            ,
            { name: 'WhatsApp', value: it?.whatsAppPhone }
          ])
        })
        .finally(() => {
          this.customerDetailLoading = false
        })
    },
    handleOpenDrawer() {
      this.$emit('show-right-info', 'contact')
    },
    handleCommand(command) {
      switch (command) {
        case 'info':
          this.$emit("show-right-info", 'contact')
          break
        case 'star':
          console.log('Special attention')
          break
        case 'clearChat':
          this.$emit('room-action-handler', {action: {name: 'clearChat'}, roomId: this.room.roomId})
          break
        case 'leaveGroup':
          this.$emit('room-action-handler', {action: {name: 'leaveGroup'}, roomId: this.room.roomId})
          break
        case 'close':
          this.$emit('close-room')
          break
        case 'delete':
          // Trigger delete chat action, consistent with room-list delete function
          this.$emit('room-action-handler', {action: {name: 'delete'}, roomId: this.room.roomId})
          break
      }
    },
    //
    menuActionHandler(action) {
      this.closeMenu()
      this.$emit('menu-action-handler', action)
    },
    closeMenu() {
      this.menuOpened = false
    },
    messageSelectionActionHandler(action) {
      this.$emit('message-selection-action-handler', action)
    }
  }
}
</script>
<style lang="scss" scoped>
.vac-avatar-image {
  border-radius: 50%;
}

.vac-avatar-image :deep(img) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

// RoomHeader 头像样式
.avatar_wrap {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar,
.avatar_placeholder {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: block;
}

.avatar_placeholder {
  background: #e8e8e8;
}

.middle {
  display: flex;
  align-items: center;
  justify-content: center;
}

.username {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
	font-size: 13px;
  color: #0D0E15;
  display: flex;
  align-items: center;
}

.last-time {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #B3B3B3;
}

.font_targert {
  font-size: 14px;
  color: black;
}

.small_box {
  width: max-content;
  margin-top: 15px;
}

.customer_title {
  font-size: 14px;
  font-weight: 500;
}
</style>